export default "__VITE_ASSET__a03d963f__"